/* src/App.module.css */

.container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.siteSelector {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 20;
  background: rgba(30, 30, 40, 0.9);
  color: white;
  padding: 10px 12px;
  border-radius: 6px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.siteLabel {
  color: #ccc;
}

.siteSelect {
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid #555;
  background: #2a2a3a;
  color: white;
  font-size: 14px;
  cursor: pointer;
  outline: none;
}

.siteSelect:focus {
  border-color: #2196f3;
}
